import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("b", null, "Patient:", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("b", null, "Height:", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("b", null, "Weight:", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("b", null, "Prescriber:", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("b", null, "Drug:", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("b", null, "Fill Date:", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("b", null, "Written Date:", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("b", null, "Order Date:", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("b", null, "Sig:", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("b", null, "Days Supply:", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("b", null, "Refills:", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("b", null, "DAW:", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("b", null, "Allergies:", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("b", null, "Diagnosis Codes:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_image_component = _resolveComponent("image-component")!
  const _component_b_table = _resolveComponent("b-table")!
  const _component_b_container = _resolveComponent("b-container")!

  return (_openBlock(), _createBlock(_component_b_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_b_row, { id: "header-row" }, {
        default: _withCtx(() => [
          _createVNode(_component_b_col, null, {
            default: _withCtx(() => [
              _createTextVNode(" RxId: " + _toDisplayString(_ctx.prescription?.rxId), 1)
            ], undefined, true),
            _: 1
          }),
          _createVNode(_component_b_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_b_button, {
                variant: "info",
                onClick: _ctx.fetchScriptHistory
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Script History")
                ], undefined, true),
                _: 1
              }, 8, ["onClick"])
            ], undefined, true),
            _: 1
          })
        ], undefined, true),
        _: 1
      }),
      _createVNode(_component_b_row, { id: "script-details-row" }, {
        default: _withCtx(() => [
          _createVNode(_component_b_col, {
            id: "image-column",
            cols: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_image_component, {
                "image-i-d": _ctx.prescription?.imageID,
                "rx-number": _ctx.prescription?.rxNumber,
                "escript-i-d": _ctx.prescription?.escriptID
              }, null, 8, ["image-i-d", "rx-number", "escript-i-d"])
            ], undefined, true),
            _: 1
          }),
          _createVNode(_component_b_col, { id: "detail-column" }, {
            default: _withCtx(() => [
              _createVNode(_component_b_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_b_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ], undefined, true),
                    _: 1
                  }),
                  _createVNode(_component_b_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_b_col, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.patient.displayNamesForPerson()), 1)
                            ], undefined, true),
                            _: 1
                          })
                        ], undefined, true),
                        _: 1
                      }),
                      _createVNode(_component_b_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_b_col, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.dateFormatter(_ctx.patient?.dateOfBirth?.toString())) + " - " + _toDisplayString(_ctx.patientAge), 1)
                            ], undefined, true),
                            _: 1
                          })
                        ], undefined, true),
                        _: 1
                      }),
                      _hoisted_2,
                      _createVNode(_component_b_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_b_col, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.prescription?.address1), 1)
                            ], undefined, true),
                            _: 1
                          })
                        ], undefined, true),
                        _: 1
                      }),
                      _createVNode(_component_b_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_b_col, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.prescription?.address2), 1)
                            ], undefined, true),
                            _: 1
                          })
                        ], undefined, true),
                        _: 1
                      }),
                      _createVNode(_component_b_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_b_col, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.prescription?.addressCity) + ", " + _toDisplayString(_ctx.prescription?.addressState) + " " + _toDisplayString(_ctx.prescription?.addressZip), 1)
                            ], undefined, true),
                            _: 1
                          })
                        ], undefined, true),
                        _: 1
                      }),
                      _hoisted_3,
                      _createVNode(_component_b_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_b_col, null, {
                            default: _withCtx(() => [
                              _hoisted_4,
                              _createTextVNode(" " + _toDisplayString(_ctx.patient.height), 1)
                            ], undefined, true),
                            _: 1
                          }),
                          _createVNode(_component_b_col, null, {
                            default: _withCtx(() => [
                              _hoisted_5,
                              _createTextVNode(" " + _toDisplayString(_ctx.patient.weight), 1)
                            ], undefined, true),
                            _: 1
                          })
                        ], undefined, true),
                        _: 1
                      })
                    ], undefined, true),
                    _: 1
                  })
                ], undefined, true),
                _: 1
              }),
              _hoisted_6,
              _createVNode(_component_b_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_b_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ], undefined, true),
                    _: 1
                  }),
                  _createVNode(_component_b_col, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.prescription?.doctorLastName) + ", " + _toDisplayString(_ctx.prescription?.doctorFirstName), 1)
                    ], undefined, true),
                    _: 1
                  })
                ], undefined, true),
                _: 1
              }),
              _hoisted_8,
              _createVNode(_component_b_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_b_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ], undefined, true),
                    _: 1
                  }),
                  _createVNode(_component_b_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_b_col, null, {
                            default: _withCtx(() => [
                              _createTextVNode(" NDC: " + _toDisplayString(_ctx.ndc), 1)
                            ], undefined, true),
                            _: 1
                          })
                        ], undefined, true),
                        _: 1
                      }),
                      _createVNode(_component_b_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_b_col, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.prescription?.productNameShort), 1)
                            ], undefined, true),
                            _: 1
                          })
                        ], undefined, true),
                        _: 1
                      })
                    ], undefined, true),
                    _: 1
                  })
                ], undefined, true),
                _: 1
              }),
              _hoisted_10,
              _createVNode(_component_b_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_b_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ], undefined, true),
                    _: 1
                  }),
                  _createVNode(_component_b_col, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.dateFormatter(_ctx.prescription?.fillDate.toString())), 1)
                    ], undefined, true),
                    _: 1
                  })
                ], undefined, true),
                _: 1
              }),
              _hoisted_12,
              _createVNode(_component_b_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_b_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _hoisted_13
                    ], undefined, true),
                    _: 1
                  }),
                  _createVNode(_component_b_col, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.dateFormatter(_ctx.prescription?.writtenDate.toString())), 1)
                    ], undefined, true),
                    _: 1
                  })
                ], undefined, true),
                _: 1
              }),
              _hoisted_14,
              _createVNode(_component_b_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_b_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _hoisted_15
                    ], undefined, true),
                    _: 1
                  }),
                  _createVNode(_component_b_col, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.dateFormatter(_ctx.prescription?.orderDate.toString())), 1)
                    ], undefined, true),
                    _: 1
                  })
                ], undefined, true),
                _: 1
              }),
              _hoisted_16,
              _createVNode(_component_b_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_b_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _hoisted_17
                    ], undefined, true),
                    _: 1
                  }),
                  _createVNode(_component_b_col, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.prescription?.directions), 1)
                    ], undefined, true),
                    _: 1
                  })
                ], undefined, true),
                _: 1
              }),
              _hoisted_18,
              _createVNode(_component_b_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_b_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _hoisted_19
                    ], undefined, true),
                    _: 1
                  }),
                  _createVNode(_component_b_col, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.prescription?.daySupply), 1)
                    ], undefined, true),
                    _: 1
                  })
                ], undefined, true),
                _: 1
              }),
              _hoisted_20,
              _createVNode(_component_b_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_b_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _hoisted_21
                    ], undefined, true),
                    _: 1
                  }),
                  _createVNode(_component_b_col, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.prescription?.refills), 1)
                    ], undefined, true),
                    _: 1
                  })
                ], undefined, true),
                _: 1
              }),
              _hoisted_22,
              _createVNode(_component_b_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_b_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _hoisted_23
                    ], undefined, true),
                    _: 1
                  }),
                  _createVNode(_component_b_col, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.prescription?.dawCode), 1)
                    ], undefined, true),
                    _: 1
                  })
                ], undefined, true),
                _: 1
              }),
              _hoisted_24,
              _createVNode(_component_b_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_b_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _hoisted_25
                    ], undefined, true),
                    _: 1
                  }),
                  _createVNode(_component_b_col, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allergies, (allergy) => {
                        return (_openBlock(), _createBlock(_component_b_row, {
                          key: allergy.allergyId
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_b_col, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(this.allergyString(allergy)), 1)
                              ], undefined, true),
                              _: 2
                            }, 1024)
                          ], undefined, true),
                          _: 2
                        }, 1024))
                      }), 128))
                    ], undefined, true),
                    _: 1
                  })
                ], undefined, true),
                _: 1
              }),
              _hoisted_26,
              _createVNode(_component_b_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_b_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _hoisted_27
                    ], undefined, true),
                    _: 1
                  }),
                  _createVNode(_component_b_col, null, {
                    default: _withCtx(() => [
                      (_ctx.diagnoses.length == 0)
                        ? (_openBlock(), _createBlock(_component_b_row, { key: 0 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_b_col, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(" No Diagnosis Codes Recorded ")
                                ], undefined, true),
                                _: 1
                              })
                            ], undefined, true),
                            _: 1
                          }))
                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.diagnoses, (diagnosis) => {
                            return (_openBlock(), _createBlock(_component_b_row, {
                              key: diagnosis.id
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_b_col, null, {
                                  default: _withCtx(() => [
                                    _createElementVNode("b", null, _toDisplayString(diagnosis.icD10Code), 1),
                                    _createTextVNode(" - " + _toDisplayString(diagnosis.description), 1)
                                  ], undefined, true),
                                  _: 2
                                }, 1024)
                              ], undefined, true),
                              _: 2
                            }, 1024))
                          }), 128))
                    ], undefined, true),
                    _: 1
                  })
                ], undefined, true),
                _: 1
              })
            ], undefined, true),
            _: 1
          })
        ], undefined, true),
        _: 1
      }),
      _withDirectives(_createVNode(_component_b_row, {
        id: "script-history-row",
        class: "my-2"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_b_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_b_table, {
                items: _ctx.scriptHistory,
                fields: _ctx.scriptHistoryFields,
                "caption-top": "",
                caption: "Prescription History",
                "sort-icon-left": "",
                outlined: ""
              }, null, 8, ["items", "fields"])
            ], undefined, true),
            _: 1
          })
        ], undefined, true),
        _: 1
      }, 512), [
        [_vShow, _ctx.scriptHistory?.length > 0]
      ])
    ], undefined, true),
    _: 1
  }))
}